import React from 'react';
import store from "../store";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import firebase from "firebase/app";
import * as STATIC from '../config/static';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import ButtonBase from '@material-ui/core/ButtonBase';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import Modal from 'react-responsive-modal';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

class TopBar extends React.Component {
    state = {
      changePass:false,
      showVideoDetail:false

    };
    logoutClick() {

      

      localStorage.removeItem('ACCOUNTCOMP');
      store.dispatch({ type: 'ACCOUNTCOMP', ACCOUNTCOMP: false });


    }
    handleChange = name => event => {

      event.preventDefault();
      this.setState({
        [name]: event.target.value

      });


    }
    toggleSound(SOUND)
    {
      let nSound = 0;
      if(SOUND == 0)
      nSound = 1;
      localStorage.setItem('SOUND',nSound);
      store.dispatch({ type: 'SOUND', SOUND: nSound });
    }
    toggleLang(LANG)
    {
      let nLANG = 'en';
      if(LANG == 'en')
      nLANG = 'vi';
      this.props.i18n.changeLanguage(nLANG);
      localStorage.setItem('LANG',nLANG);
      store.dispatch({ type: 'LANG', LANG: nLANG });
    }
    helpClick(){
      //this.setState({showVideoDetail:{link:"http://family.superbrain.vn/videos/hd_practice.mp4",name:'HD'}})
      window.open("/assets/web/HD_Online.pdf", '_blank');
    }
    async changePass(){
      let _this = this;
      const {password,new_password,cnew_password} = this.state;
      if(!password||password.trim().length==0)
      {
        STATIC.NotificationManager.error(_this.props.t('common.error_pass'));
        return;
      }
      if(!new_password || new_password.trim().length<4)
      {
        STATIC.NotificationManager.error(_this.props.t('common.error_pass_larger'));
        return;
      }
      if(new_password!=cnew_password)
      {
        STATIC.NotificationManager.error(_this.props.t('common.error_pass_confirm'));
        return;
      }
      let ACCOUNT = store.getState().ACCOUNT;
      await _this.setState({loading:true});
      let res = await STATIC.postFormData(STATIC.API_USER_CHANGEPASS,{username:ACCOUNT.userlog,password,new_password});
      console.log(res);
      if(res && res.status==1)
      {
        _this.setState({ changePass:false,password:'',new_password:'',cnew_password:''});
        STATIC.NotificationManager.success(_this.props.t('common.success'));
      }
      else {
        STATIC.NotificationManager.error(_this.props.t('common.error_pass_failed'));

      }
      await _this.setState({loading:false});
    }

    render() {
        const { classes,t,screen } = this.props;
        const {changePass,password,new_password,cnew_password,showVideoDetail} = this.state;
        let width = this.props.width;
        if(this.props.width>640)
        width = 640;
        let fLarge = width * 0.06;
        let fTitle = width * 0.04;
        let fNormal = width * 0.03;
        let fSmall = width * 0.02;
        let ACCOUNT = store.getState().ACCOUNTCOMP;
        let SOUND = store.getState().SOUND;
        let LANG = store.getState().LANG;
        return (

              <div style={{position: 'fixed', top: 0, right: 0, backgroundColor: '#fdce07',zIndex:10,borderRadius: "0 0 0 " + STATIC.calSize(10, STATIC.DWIDTH, width) + "px"}}>


<ButtonBase
                  focusRipple
                  onClick={() => this.toggleLang(LANG)}
                  style={{  fontSize: fNormal, padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px') , color: "#053f22" }}>
                  {LANG=='en'?"EN":'VI'}{" | "}
              </ButtonBase>
              {ACCOUNT?<ButtonBase
                focusRipple
                onClick={() => this.logoutClick()}
                style={{  fontSize: fNormal, padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'), color: "#053f22" }}>
                {ACCOUNT.type==0?ACCOUNT.mahs:ACCOUNT.inputuser} <ExitToAppIcon style={{fontSize:fTitle}} />
            </ButtonBase>:false}
            {screen&&screen=="practice"?<ButtonBase
              focusRipple
              onClick={() => this.helpClick()}
              style={{  fontSize: fNormal, padding: (STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px') , color: "#053f22" }}>
              {" | "}{t('common.help')}
          </ButtonBase>:false}
            <Modal styles={{overlay:{padding:0}, modal: { minWidth: width , background: 'none',textAlign:'center' } }} open={changePass} onClose={() => this.setState({ changePass: false,password:'',new_password:'',cnew_password:''})} center>
              <div style={{ width: width*0.98, backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex',flexDirection:'column' }}>

                    <div style={{textAlign: 'center', fontSize: fLarge, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.change_password')}</div>
                     <div  style={{display:'flex',flexDirection:"column",justifyContent:'center'}}>
                      <div style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: 10 }}>

                        <input
                          onChange={this.handleChange('password')}
                          value={password}
                          type="password"
                          placeholder={t('login.password')}
                          style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                      </div>
                      <div style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: 10 }}>

                        <input
                          onChange={this.handleChange('new_password')}
                          value={new_password}
                          type="password"
                          placeholder={t('common.new_password')}
                          style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                      </div>
                      <div style={{ padding: '0px 0px 0px ' + STATIC.calSize(10, STATIC.DWIDTH, width) + 'px', marginBottom: 10 }}>

                        <input
                          onChange={this.handleChange('cnew_password')}
                          value={cnew_password}
                          type="password"
                          placeholder={t('common.new_password_confirm')}
                          style={{ border: 'none', height: STATIC.calSize(65, STATIC.DWIDTH, width), width: '100%', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(5, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(30, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                      </div>
                      <div>
                        <Button disabled={this.state.loading} style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'),marginLeft:'auto', minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.changePass()}>
                          {t('common.change_password')}
                              </Button>
                      </div>
                    </div>
                    </div>
                  </div>
                </Modal>
                <Modal styles={{overlay:{padding:0}, modal: { minWidth: width, textAlign: 'center', background: 'none', boxShadow: 'none', color: "white",padding:0 } }} showCloseIcon={true} focusTrapped={false} open={showVideoDetail} onClose={() => this.setState({ showVideoDetail: false })} center>
                  <video style={{width: width}} src={showVideoDetail?showVideoDetail.link:false} poster controls />
                </Modal>
          </div>

        );
    }
}

TopBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(TopBar));
